import { render, staticRenderFns } from "./PriceListModal.vue?vue&type=template&id=c8d0e298&"
import script from "./PriceListModal.vue?vue&type=script&lang=js&"
export * from "./PriceListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports